import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/shared/config/i18n";
import { Providers } from "@/app/providers";
import { AppRouter } from "@/app/router";
import { env } from "@/shared/config/env";
import { initErrorReporting, reportWebVitals } from "@/shared/observability";
import "@/app/styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </StrictMode>,
);

// After first paint: neither of these may delay the app.
const idle = (fn: () => void) =>
  "requestIdleCallback" in window ? window.requestIdleCallback(fn) : setTimeout(fn, 1500);
idle(() => {
  void initErrorReporting(env.VITE_SENTRY_DSN, import.meta.env.MODE);
  void reportWebVitals(env.VITE_VITALS_URL, import.meta.env.DEV);
});
